import { render, staticRenderFns } from "./cash-top-up.vue?vue&type=template&id=35272f7e&"
import script from "./cash-top-up.vue?vue&type=script&lang=ts&"
export * from "./cash-top-up.vue?vue&type=script&lang=ts&"
import style0 from "./cash-top-up.vue?vue&type=style&index=0&id=35272f7e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports